<!-- 论文指导老师 -->
<template>
    <div class="el-Instructor">
        <el-row class="page_content">
            <h1 class="head_title">论文指导老师</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="教师姓名">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="教师编号">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="联系电话">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="QQ">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="电子邮箱">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "Instructor",
  data() {
    return {
        tableData: [],
        dialogImageUrl: '',
        dialogVisible: false
    };
  },
  created() {
   
  },
  methods: {
    
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-Instructor{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>


// WEBPACK FOOTER //
// src/pages/dissertation/Instructor.vue